
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'ปักหมุด',
	'find_label': 'ค้นหา',
	'findCancelLabel': 'ยกเลิก',
	'sourcePaneLabel': 'เลือกแหล่งที่มา',
	'sourcePaneContentLabel': 'เลือกแหล่งที่มา',
	'addDataDashboardCoachMarkContents': 'ลากและดร็อปข้อมูจากพาเนลข้อมูลบนแดชบอร์ดของคุณ',
	'addDataStoryCoachMarkContents': 'ลากและปล่อยจากพาเนลข้อมูลลงบนเรื่องของคุณ',
	'addDataCoachMarkTitle': 'เพิ่มข้อมูล',
	'selectSourcesText': 'เลือกและเพิ่มแหล่งข้อมูลเพื่อบิลด์ %{app} ของคุณ',
	'selectSourcesLabel': 'เลือกแหล่งที่มา',
	'errorSourcesTitle': 'ไม่สามารถโหลดแผนผังข้อมูล',
	'errorLoadingDataSources': 'มีข้อผิดพลาดเกิดขึ้นขณะโหลดรายการชุดข้อมูล',
	'errorLoadingDataTree': 'เกิดข้อผิดพลาดขณะโหลดแผนผัง',
	'dataSetPaneLastUpdated': 'อัพเดตล่าสุด: %{date}',
	'dataSourcePaneDateUnknown': 'ไม่รู้จัก',
	'moreTitle': 'เพิ่มเติม',
	'backLabel': 'ย้อนกลับ',
	'addDataSourceDialogTitle': 'เพิ่มแหล่งข้อมูล',
	'addDataSourceDialogButtonLabel': 'เพิ่ม',
	'dlg_use': 'ใช้',
	'dlg_RelinkDataSourceTitle': 'แทนที่ชุดข้อมูล \'%{dataSourceName}\' ด้วย...',
	'propertiesDialogTitle': 'คุณสมบัติ',
	'missingDataSetData': 'ข้อมูลสำหรับชุดข้อมูลนี้ไม่พร้อมใช้งาน รีเฟรชชุดข้อมูล หรือติดต่อผู้ดูแลระบบของคุณสำหรับการเข้าถึงแหล่งข้อมูล',
	'errorLoadingSource': 'ไม่ได้โหลดข้อมูลเมตาสำหรับ \'%{sourceName}\' โปรดติดต่อผู้ดูแลระบบของคุณสำหรับรายละเอียด',
	'errorMessageTitle': 'ข้อผิดพลาด',
	'calculation_navigation_in_use': 'การลบการคำนวณหรือพาธการนำทางจะทำให้การตรวจสอบความถูกต้องสำหรับวิชวลไลเซชันทั้งหมดผิดพลาดซึ่งอ้างอิงถึงไอเท็มที่ลบทิ้ง คุณแน่ใจว่าต้องการลบหรือใช่ไม่',
	'delete_confirm': 'ยืนยันการลบ',
	'previewUnavailable': 'ถาดข้อมูลและตัวกรองโกลบอลไม่พร้อมใช้งานสำหรับแพ็กเกจชนิดนี้',
	'contextualGridTabName': 'ข้อมูลวิชวลไลเซชัน',
	'DATA_TRAY_no_data_text': '\'ข้อมูลของคุณจะปรากฏขึ้นที่นี่\'',
	'contextualGridMenuLabel': 'เมนูข้อมูลวิชวลไลเซชัน',
	'contextualGridExport': 'เอ็กซ์พอร์ต',
	'nullValueText': 'Null',
	'forecastDetailsTabName': 'รายละเอียดสถิติการคาดการณ์',
	'forecastDetailsModelLabel': 'โมเดล',
	'forecastDetailsQualityMetricLabel': 'มาตรวัดที่แม่นยำ',
	'forecastDetailsSmoothingCoefLabel': 'พารามิเตอร์',
	'forecastDetailsDiagnostics': 'การวินิจฉัย',
	'forecastDetailsForecastLabel': 'คาดการณ์ล่วงหน้า',
	'forecastDetailsStatusLabel': 'สถานะ',
	'forecastDetailsAccuracyPercentLabel': '% ความแม่นยำ',
	'forecastDetailsTrendLabel': 'แนวโน้ม',
	'forecastDetailsSeasonLabel': 'ฤดูกาล',
	'forecastDetailsSeasonalPeriodLabel': 'ระยะเวลาตามฤดูกาล',
	'forecastDetailsAlphaLabel': 'Alpha',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'ไม่มีจำนวนนับ',
	'forecastDetailsSeriesLengthLabel': 'ความกว้างของซีรีย์',
	'forecastDetailsIgnoredPeriods': 'ช่วงเวลาที่ละเว้น',
	'forecastDetailsTrendStrength': 'ความแข็งแรงของแนวโน้ม',
	'forecastDetailsSeasonalityStrength': 'ความแข็งแรงตามฤดูกาล',
	'forecastDetailsTimeDeltaUnit': 'ช่วงวันที่ / เวลา',
	'forecastDetailsNotes': 'บันทึก'
});
